import React from "react";
import { useNavigate } from "react-router-dom";
import { useAssignmentStore } from "../../assignmentStore";
import { AssignmentCard } from "components";
import { Assignment } from "types";
import { useRecordResourceView } from "utils/hooks";

const AssignmentsForPatientsColumn = () => {
  const history = useNavigate();
  const { state } = useAssignmentStore();
  const { recordResourceView } = useRecordResourceView();

  const filteredAssignments = state.assignments?.filter(
    (a) => a.type !== "SAFETY_PLAN"
  );

  const recordStats = (assignment: Assignment) => {
    if (!assignment || assignment?.category !== "INFOSHEET") return null;
    recordResourceView(assignment.uuid, "assignment");
  };

  return (
    <>
      {filteredAssignments?.map((assignment: any) => (
        <AssignmentCard
          isActive={state.activeAssignment?.uuid === assignment.uuid}
          key={assignment.uuid}
          showSubtitle={false}
          assignment={assignment}
          hasActions={true}
          onCardClick={async () => {
            recordStats(assignment);
            history(`/your-assignments/${assignment.slug}`);
          }}
        />
      ))}
    </>
  );
};

export default AssignmentsForPatientsColumn;
